var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    className: "sc-gtssRu gmjWml",
    viewBox: "0 0 160 160"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.115 0h160v160h-160z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 62,
    x: 47.115,
    y: 62,
    fill: "#E3EBF4",
    rx: 2,
    transform: "rotate(-7 93.115 93)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7 -172.69 406.466)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 90,
    fill: "#7E9FFB",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 5,
    x: 15.955,
    y: 16.487,
    fill: "#C1D8FD",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 5,
    x: 26.49,
    y: 65.232,
    fill: "#C1D8FD",
    rx: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6148F1",
    fillRule: "nonzero",
    d: "M81.258 71.217c11.047 11.047 11.047 28.958 0 40.005-9.983 9.983-25.573 10.944-36.635 2.883l-20.082 20.08a2 2 0 0 1-2.828 0l-3.422-3.422a2 2 0 0 1 0-2.829l20.08-20.08c-8.062-11.063-7.1-26.653 2.883-36.637 11.047-11.047 28.957-11.047 40.004 0m-6.25 6.251c-7.595-7.595-19.909-7.595-27.503 0s-7.595 19.908 0 27.503 19.908 7.595 27.503 0 7.594-19.908 0-27.503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1D8FD",
    d: "m57.959 87.217 22.717 2.788q.039.617.039 1.242c0 3.859-1.124 7.455-3.062 10.48l-21.157-2.6a1 1 0 0 1-.87-1.114l1.218-9.926a1 1 0 0 1 1.115-.87"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.043,
    cy: 24.733,
    r: 4.8,
    fill: "#E3EBF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.535,
    cy: 9.84,
    r: 2.4,
    fill: "#6148F1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.535,
    cy: 123.306,
    r: 2.4,
    fill: "#E3EBF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.469,
    cy: 153.106,
    r: 3.2,
    fill: "#7E9FFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.849,
    cy: 140.082,
    r: 3.2,
    fill: "#C1D8FD"
  }))));
};
export default SvgNotFound;